
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/categorie/[slug]",
      function () {
        return require("private-next-pages/shop/categorie/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/categorie/[slug]"])
      });
    }
  